import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import SearchResult from "@/components/SearchResult";
import Head from "next/head";
import { useContentfulTranslations } from "@/utils/contentfulTranslations";
import { useLocale } from "@/hooks/useLocale";
const Loader = dynamic(() => import("@/components/loader"));

const LandingPage = ({
  locale = "en",
  params = {},
  plpData = {},
  facetLabelsState = {},
  search = "",
  apacConfigurationsData = {},
}) => {
  const router = useRouter();
  const traslationLocale = useLocale();
  const slugKey =
    search ||
    (Array.isArray(params?.params)
      ? params.params.join("/")
      : params?.params || "");

  const { SearchResultPageTitle } = useContentfulTranslations();

  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  const { type } = router.query;
  const transitionKey = `${router.pathname}_${slugKey}`;

  const pageTitle = `${slugKey} | ${SearchResultPageTitle[traslationLocale]}`;
  return (
    <>
      <Head>
        <title>{`${pageTitle}`}</title>
      </Head>
      <SearchResult
        key={transitionKey}
        locale={locale}
        params={params}
        search={search}
      />
    </>
  );
};

export async function getServerSideProps({
  req,
  params,
  preview,
  locale,
  query,
}) {
  const { search = "" } = query;
  const defaultLocale =
    locale === "default" ? process.env.NEXT_PUBLIC_LW_LANGUAGE : locale;
  const {
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    apacConfigurationsData,
    translations,
  } = await getPageShellDataSafely({
    slug: `/results`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: false,
    locale,
  });

  return {
    props: {
      //   pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      apacConfigurationsData,
      translations,
      locale,
      search,
      params,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  locale: PropTypes.string,
  plpData: PropTypes.object,
  facetLabelsState: PropTypes.object,
  categoryConfig: PropTypes.string,
  params: PropTypes.object,
};

export default LandingPage;
